export const CONNECTION_KEY_HEADER = "x-prpcow-key";
export const CONNECTION_KEY_QUERY = "k";
export const CONNECTION_KEY_PROTOCOL_PREFIX = "prpcow.k.";

function toBase64Url(text: string): string {
	const bytes = new TextEncoder().encode(text);
	let binary = "";
	for (let i = 0; i < bytes.length; i += 1) {
		binary += String.fromCharCode(bytes[i]);
	}
	return btoa(binary)
		.replace(/\+/g, "-")
		.replace(/\//g, "_")
		.replace(/=+$/g, "");
}

export function connectionKeyProtocol(key: string): string {
	return `${CONNECTION_KEY_PROTOCOL_PREFIX}${toBase64Url(key)}`;
}

export function appendConnectionKeyToUrl(
	address: string | URL,
	key: string,
): string | URL {
	try {
		const url =
			typeof address === "string"
				? new URL(address)
				: new URL(address.toString());
		url.searchParams.set(CONNECTION_KEY_QUERY, key);
		return typeof address === "string" ? url.toString() : url;
	} catch {
		const raw = String(address);
		const sep = raw.includes("?") ? "&" : "?";
		return `${raw}${sep}${CONNECTION_KEY_QUERY}=${encodeURIComponent(key)}`;
	}
}
